import { PdfAreaBreakPageAlways, PdfH1, PdfTable } from 'pages/v2/compiler/PDF/Styles.styled';
import { ScenarioItemModel } from 'types/types';

type TProps = {
  scenario: ScenarioItemModel;
  index: number;
};

const AdditionalScenarioInformationPdf = ({ scenario, index }: TProps) => {
  return (
    <PdfAreaBreakPageAlways>
      <PdfH1>Additional Scenario {index}</PdfH1>
      <PdfTable>
        <thead>
          <tr>
            <th style={{ width: '30%' }}></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Name of the additional scenario</td>
            <td>{scenario.name}</td>
          </tr>
          <tr>
            <td>Description of the additional scenario</td>
            <td>{scenario.description}</td>
          </tr>
        </tbody>
      </PdfTable>
    </PdfAreaBreakPageAlways>
  );
};

export default AdditionalScenarioInformationPdf;
